<organization-select    #orgManager
                        autoSelectFirst = "true"
                        class           = "mr-3"
                        (change)        = "onOrgChange($event)"></organization-select>

<site-select    #siteManager
                [org]           = "orgManager?.currentValue"
                autoSelectFirst = "true"
                class           = "mr-3"
                (change)        = "onSiteChange($event)"></site-select>
<br>
<div class = "file-container" *ngIf="site">
    <cq-file    class           =   "mx-auto mt-0 w-100 pr-3"
                label           =   "media.label.wapp.logo"
                [formCtrl]      =   "wapp_logo"
                [validators]    =   "wapp_logo_validators"
                appearance      =   "outline"
                [destination]   =   "getWappLogoDest()"
                missingImagePreview ></cq-file>


    <cq-file    class           =   "mx-auto mt-0 w-100 pr-3"
                label           =   "media.label.mapp.logo"
                [formCtrl]      =   "mapp_logo"
                [validators]    =   "mapp_logo_validators"
                appearance      =   "outline"
                [destination]   =   "getMappLogoDest()"
                missingImagePreview></cq-file>

                
    <cq-file    class           =   "mx-auto mt-0 w-100 pr-3"
                label           =   "media.label.codi.logoh"
                [formCtrl]      =   "codi_logoh"
                [validators]    =   "codi_validators"
                appearance      =   "outline"
                [destination]   =   "getCodiLogoHDest()"
                missingImagePreview></cq-file>

    <cq-file    class           =   "mx-auto mt-0 w-100 pr-3"
                label           =   "media.label.codi.logof"
                [formCtrl]      =   "codi_logof"
                [validators]    =   "codi_validators"
                appearance      =   "outline"
                [destination]   =   "getCodiLogoFDest()"
                missingImagePreview></cq-file>
    <cq-file    class           =   "mx-auto mt-0 w-100 pr-3"
                label           =   "media.label.codi.back"
                [formCtrl]      =   "codi_back"
                [validators]    =   "codi_validators"
                appearance      =   "outline"
                [destination]   =   "getCodiBackDest()"
                missingImagePreview></cq-file>


    <cq-file    class           =   "mx-auto mt-0 w-100 pr-3"
                label           =   "media.label.tick.logo"
                [formCtrl]      =   "tick_logo"
                [validators]    =   "tick_logo_validators"
                appearance      =   "outline"
                [destination]   =   "getTickLogoDest()"
                missingImagePreview></cq-file>
    <cq-file    class           =   "mx-auto mt-0 w-100 pr-3"
                label           =   "media.label.tick.promo"
                [formCtrl]      =   "tick_promo"
                [validators]    =   "tick_promo_validators"
                appearance      =   "outline"
                [destination]   =   "getTickPromoDest()"
                missingImagePreview></cq-file>

    <cq-file    class           =   "mx-auto mt-0 w-100 pr-3"
                label           =   "media.label.summ.logoh"
                [formCtrl]      =   "summ_logoh"
                [validators]    =   "summ_validators"
                appearance      =   "outline"
                [destination]   =   "getSummLogoHDest()"
                missingImagePreview></cq-file>
               
    <cq-file    class           =   "mx-auto mt-0 w-100 pr-3"
                label           =   "media.label.summ.logof"
                [formCtrl]      =   "summ_logof"
                [validators]    =   "summ_validators"
                appearance      =   "outline"
                [destination]   =   "getSummLogoFDest()"
                missingImagePreview></cq-file>

    <cq-file    class           =   "mx-auto mt-0 w-100 pr-3"
                label           =   "media.label.summ.back"
                [formCtrl]      =   "summ_back"
                [validators]    =   "summ_validators"
                appearance      =   "outline"
                [destination]   =   "getSummBackDest()"
                missingImagePreview></cq-file>
</div>
